<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle1"><a id="halftitle"></a><a id="page_vii"></a><strong>T.H.U.G. L.I.F.E.</strong><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?502df02b